export const EncounterStatus_Initial = 'initial';
const EncounterStatus_Viewed = 'viewed';
const EncounterStatus_Managed = 'managed';
const EncounterStatus_Documented = 'documented';
const EncounterStatuses = [EncounterStatus_Initial, EncounterStatus_Viewed, EncounterStatus_Managed, EncounterStatus_Documented];
//# sourceMappingURL=types.js.map